import { render, staticRenderFns } from "./ProjectGroupEditForm.vue?vue&type=template&id=0c64160d"
import script from "./ProjectGroupEditForm.vue?vue&type=script&lang=js"
export * from "./ProjectGroupEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports